import { useEffect, useState } from 'react';
import { Slider, Box } from '@evaneos/b2b-ui';
import { IntlFormatters } from 'react-intl';

type Props = {
    maxRange: number;
    onChange: (values: readonly number[]) => void;
    values: number[] | null;
    formatNumber: IntlFormatters['formatNumber'];
};

export const RangeInput = ({ maxRange, onChange, values, formatNumber }: Props) => {
    const [internalValues, setInternalValues] = useState<number[]>(values ?? [0, maxRange]);

    useEffect(() => {
        if (values) setInternalValues(values);
    }, [values]);

    const renderHandleValue = (value: number): string => {
        const price = formatNumber(value, {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        });
        return value === maxRange ? `>${price}` : price;
    };

    const handleChange = (_: Event, newValue: number | number[]) => {
        const val = Array.isArray(newValue) ? newValue : [newValue];
        setInternalValues(val);
        onChange(val);
    };

    return (
        <Box sx={{ paddingX: 2.5, paddingY: 1 }} data-testid="range-input">
            <Slider
                value={internalValues}
                onChange={handleChange}
                valueLabelDisplay="on"
                min={0}
                max={maxRange}
                step={1}
                disableSwap
                getAriaValueText={renderHandleValue}
                valueLabelFormat={renderHandleValue}
            />
        </Box>
    );
};
